export default "__VITE_ASSET__B7C78cTe__"